<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Patrick Shirley, a new author, is the youngest son of John Shirley, who wrote and illustrated the main account. Patrick’s mother, Alice Shirley, wanted his father’s richly illustrated account to be shared with the general public alongside the account of the German submariner Herbert Lochner who was saved by the Royal Navy ship Alnwick Castle. Patrick wanted this to be a tribute to the bravery of both sides in one of the most inhospitable marine environments to fight a war. For this reason, he wanted both accounts to be published together. To survive the Arctic war was a blessing and for that both families are truly thankful. Patrick was also inspired to study Geography by his father at Lincoln Christ’s Hospital School and he has a successful career in IT consultancy. He is happily married with two beautiful daughters.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?49688a5d